<!--<section>
  <div id="space" style="height: 30px;background-color: #001530;"></div>
  <div id="carousel">
    <div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="carousel">
      <ol class="carousel-indicators">
        <li data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" class="active" aria-label="Slide 1" aria-current="true">LOOKING FOR AN APPEARANCE ATTORNEY?</li>
        <li data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2" class="">LOOKING FOR COURT APPERANCE OPPORTUNITY?</li>
      </ol>
      <div class="carousel-inner">
        <div class="carousel-item active">
          <div class="carousel-caption d-md-block">
            <div class="centerMe">
              <div class="col-md-10 col-lg-8">
                <div class="text-center">
                  <h5>SEARCH ATTORNEY</h5>
                </div>
                <form class="form-group" action="https://nascent.co.in/os_web/videtur2/attorney.html">
                  <div class="input-group mb-3">
                    <input type="text" class="form-control search-control" placeholder="Practice Area ......" aria-label="Practive Area">&nbsp;
                    <input type="text" class="form-control search-control" placeholder="Location ......" aria-label="Location">
                    <div class="input-group-append">
                      <span class="input-group-text"><button class="border-0"><i class="fa fa-search mt-2" aria-hidden="true"></i></button></span>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div class="message">
              <h4>Schedule appearance coverage in minutes, whenever you need it <span style="color: #6ace00">in just a few steps:</span></h4>
            </div>
            <div class="steps">
              <div class="row">
                <div class="col-lg-2 col-md-6 col-sm-12 right-border">
                  <p>
                    <span style="color: #6ace00">1. Sign Up</span><br>
                    <span style="font-size:2rem;"><i class="fa fa-user-plus" aria-hidden="true"></i></span><br>
                    Create your account and set up payment information to get started
                  </p>
                </div>
                <div class="col-lg-2 col-md-6 col-sm-12 right-border">
                  <p>
                    <span style="color: #6ace00">2. Provide Case Details</span><br>
                    <span style="font-size:2rem;"><i class="fa fa-calendar" aria-hidden="true"></i></span><br>
                    Choose the date, practice area, and location to get matched with the right attorney
                  </p>
                </div>
                <div class="col-lg-2 col-md-6 col-sm-12 right-border">
                  <p>
                    <span style="color: #6ace00">3. Connect with an Attorney</span><br>
                    <span style="font-size:2rem;"><i class="fa fa-handshake" aria-hidden="true"></i></span><br>
                    Select the attorney of your choice to handle your court appearance
                  </p>
                </div>
                <div class="col-lg-2 col-md-6 col-sm-12 right-border">
                  <p>
                    <span style="color: #6ace00">4. Receive Confirmation</span><br>
                    <span style="font-size:2rem;"><i class="fa fa-check-circle" aria-hidden="true"></i></span><br>
                    Select the attorney of your choice to handle your court appearance
                  </p>
                </div>
                <div class="col-lg-2 col-md-6 col-sm-12 right-border">
                  <p>
                    <span style="color: #6ace00">5. Court Representation</span><br>
                    <span style="font-size:2rem;"><i class="fa fa-gavel" aria-hidden="true"></i></span><br>
                    Select the attorney of your choice to handle your court appearance
                  </p>
                </div>
                <div class="col-lg-2 col-md-6 col-sm-12 ">
                  <p>
                    <span style="color: #6ace00">6. Appearance Update</span><br>
                    <span style="font-size:2rem;"><i class="fa fa-clipboard" aria-hidden="true"></i></span><br>
                    Receive report on the case outcome
                  </p>
                </div>
              </div>
            </div>
          </div>
          <img src="/assets/img/slider_3.jpg" class="d-block w-100" alt="Search Attorney">

        </div>
        <div class="carousel-item">
          <div class="carousel-caption d-md-block">

            <div class="centerMe">
              <div class="col-md-10 col-lg-8">
                <div class="text-center">
                  <h5>SEARCH APPEARANCE</h5>
                </div>
                <form class="form-group" action="https://nascent.co.in/os_web/videtur2/appearances.html">
                  <div class="input-group mb-3">
                    <input type="text" class="form-control search-control" placeholder="Case Type ......" aria-label="Practive Area">&nbsp;
                    <input type="text" class="form-control search-control" placeholder="Location ......" aria-label="Location">
                    <div class="input-group-append">
                      <span class="input-group-text"><button class="border-0"><i class="fa fa-search mt-2" aria-hidden="true"></i></button></span>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div class="message">
              <h4>Discover court appearance opportunities in minutes <span style="color: #6ace00">in just a few steps:</span></h4>
            </div>

            <div class="steps">
              <div class="row">
                <div class="col-lg-2 col-md-6 col-sm-12 right-border">
                  <p>
                    <span style="color: #6ace00">1. Sign Up</span><br>
                    <span style="font-size:2rem;"><i class="fa fa-user-plus" aria-hidden="true"></i></span><br>
                    Create your account and share your details to match seamlessly with the right opportunities!
                  </p>
                </div>
                <div class="col-lg-2 col-md-6 col-sm-12 right-border">
                  <p>
                    <span style="color: #6ace00">2. Set Up Payment</span><br>
                    <span style="font-size:2rem;"><i class="fa fa-credit-card" aria-hidden="true"></i></span><br>
                    Add your payment details to ensure you get paid quickly and securely for your workp&gt;
                  </p>
                </div>
                <div class="col-lg-2 col-md-6 col-sm-12 right-border">
                  <p>
                    <span style="color: #6ace00">3. Get Hired</span><br>
                    <span style="font-size:2rem;"><i class="fa fa-check-circle" aria-hidden="true"></i></span><br>
                    Review opportunities and get hired for appearances that match your skills and availability
                  </p>
                </div>
                <div class="col-lg-2 col-md-6 col-sm-12 right-border">
                  <p>
                    <span style="color: #6ace00">4. Attend the Appearance</span><br>
                    <span style="font-size:2rem;"><i class="fa fa-gavel" aria-hidden="true"></i></span><br>
                    Appear in court
                  </p>
                </div>
                <div class="col-lg-2 col-md-6 col-sm-12">
                  <p>
                    <span style="color: #6ace00">5. Get Paid</span><br>
                    <span style="font-size:2rem;"><i class="fa fa-dollar" aria-hidden="true"></i></span><br>
                    Select the attorney of your choice to handle your court appearance
                  </p>
                </div>
              </div>
            </div>
          </div>
          <img src="/assets/img/slider_4.jpg" class="d-block w-100" alt="Search Appearance">
        </div>
      </div>
    </div>
  </div>
</section>-->

<section>
  <div id="space" style="height: 20px;background-color: #001530;"></div>
  <div id="carousel">
    <div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="carousel">
      <!--<div class="carousel-indicators">
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active"
                aria-current="true" aria-label="Slide 1" (click)="Check(true)">
          LOOKING FOR AN ATTORNEY?
        </button>
        <button type="button" data-bs-target="#carouselExampleIndicators" (click)="Check(false)" data-bs-slide-to="1" aria-label="Slide 2">
          SEEKING AN APPEARANCE OPPORTUNITY?
        </button>
      </div>-->
      <ol class="carousel-indicators">
        <li data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" class="active" aria-label="Slide 1" aria-current="true"
            (click)="Check(true)">LOOKING FOR AN APPEARANCE ATTORNEY?</li>
        <li data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2" class=""
            (click)="Check(false)">LOOKING FOR A COURT APPEARANCE OPPORTUNITY?</li>
      </ol>
      <div class="carousel-inner">
        <div class="carousel-item active">
          <div class="carousel-caption d-md-block">
            <div class="centerMe">
              <div class="col-md-10 col-lg-8">
                <div class="text-center">
                  <h5>SEARCH ATTORNEY</h5>
                </div>
                <div class="text-center CenterControl">
                  <app-top-filter [CalledFor]="'Attorney'" [displayat]="'H'"></app-top-filter>
                </div>
              </div>
            </div>
            <div class="message">
              <h4>Schedule appearance coverage in minutes, whenever you need it, <span style="color: #6ace00">in just a few steps:</span></h4>
            </div>
            <div class="steps">
              <div class="row" style="justify-content:center;">
                <div class="col-lg-2 col-md-6 col-sm-12 right-border">
                  <p>
                    <span style="color: #6ace00">1. Sign Up</span><br />
                    <span style="font-size:2rem;"><i class="fa fa-user-plus"></i></span><br />
                    Create your account and set up payment information to get started
                  </p>
                </div>
                <div class="col-lg-2 col-md-6 col-sm-12 right-border">
                  <p>
                    <span style="color: #6ace00">2. Provide Case Details</span><br />
                    <span style="font-size:2rem;"><i class="fa fa-calendar"></i></span><br />
                    Choose the date, practice area, and location to get matched with the right attorney
                  </p>
                </div>
                <div class="col-lg-2 col-md-6 col-sm-12 right-border">
                  <p>
                    <span style="color: #6ace00">3. Connect with an Attorney</span><br />
                    <span style="font-size:2rem;"><i class="fa fa-handshake-o"></i></span><br />
                    Select the attorney of your choice to handle your court appearance
                  </p>
                </div>
                <div class="col-lg-2 col-md-6 col-sm-12 right-border">
                  <p>
                    <span style="color: #6ace00">4. Receive Confirmation</span><br />
                    <span style="font-size:2rem;"><i class="fa fa-check-circle"></i></span><br />
                    Select the attorney of your choice to handle your court appearance
                  </p>
                </div>
                <div class="col-lg-2 col-md-6 col-sm-12 right-border">
                  <p>
                    <span style="color: #6ace00">5. Court Representation</span><br />
                    <span style="font-size:2rem;"><i class="fa fa-gavel"></i></span><br />
                    Select the attorney of your choice to handle your court appearance
                  </p>
                </div>
                <div class="col-lg-2 col-md-6 col-sm-12 ">
                  <p>
                    <span style="color: #6ace00">6. Appearance Update</span><br />
                    <span style="font-size:2rem;"><i class="fa fa-clipboard"></i></span><br />
                    Receive report on the case outcome
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!--<img src="assets/img/slider/new-slider-1.jpg" class="d-block w-100" alt="Search for Attorneys">-->          
          <img src="/assets/img/slider_3.jpg" class="d-block w-100" alt="Search Attorney">
        </div>

        <!--</div>-->
        <div class="carousel-item">
          <div class="carousel-caption d-md-block">
            <!--<h5>Second slide label</h5>
            <p>Some representative placeholder content for the second slide.</p>-->
            <div class="centerMe">
              <div class="col-md-10 col-lg-8">
                <div class="text-center">
                  <h5>SEARCH APPEARANCE</h5>
                </div>
                <div class="text-center CenterControl">
                  <app-top-filter [CalledFor]="'Appearance'" [displayat]="'H'"></app-top-filter>
                </div>
              </div>
            </div>
            <!--</div>-->


            <div class="message">
              <h4>Discover court appearance opportunities in minutes, <span style="color: #6ace00">in just a few steps:</span></h4>
            </div>

            <div class="steps">
              <div class="row" style="justify-content:center;">
                <div class="col-lg-2 col-md-6 col-sm-12 right-border">
                  <p>
                    <span style="color: #6ace00">1. Sign Up</span><br />
                    <span style="font-size:2rem;"><i class="fa fa-user-plus"></i></span><br />
                    Create your account and share your details to match seamlessly with the right opportunities!
                  </p>
                </div>
                <div class="col-lg-2 col-md-6 col-sm-12 right-border">
                  <p>
                    <span style="color: #6ace00">2. Set Up Payment</span><br />
                    <span style="font-size:2rem;"><i class="fa fa-credit-card"></i></span><br />
                    Add your payment details to ensure you get paid quickly and securely for your workp>
                </div>
                <div class="col-lg-2 col-md-6 col-sm-12 right-border">
                  <p>
                    <span style="color: #6ace00">3. Get Hired</span><br />
                    <span style="font-size:2rem;"><i class="fa fa-check-circle"></i></span><br />
                    Review opportunities and get hired for appearances that match your skills and availability
                  </p>
                </div>
                <div class="col-lg-2 col-md-6 col-sm-12 right-border">
                  <p>
                    <span style="color: #6ace00">4. Attend the Appearance</span><br />
                    <span style="font-size:2rem;"><i class="fa fa-gavel"></i></span><br />
                    Appear in court
                  </p>
                </div>
                <div class="col-lg-2 col-md-6 col-sm-12">
                  <p>
                    <span style="color: #6ace00">5. Get Paid</span><br />
                    <span style="font-size:2rem;"><i class="fa fa-dollar"></i></span><br />
                    Once your appearance is complete, receive your payment quickly and securely
                  </p>
                </div>
              </div>
            </div>
          </div>
          <img src="/assets/img/slider_4.jpg" class="d-block w-100" alt="Search Appearance">
          <!--<img src="assets/img/slider/new-slider-2.jpg" class="d-block w-100" alt="Search for Appearances">-->
          <!--</div>-->
        </div>
        <!--<button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>-->
      </div>
    </div>
  </div>
</section>
